import JSEncrypt from "jsencrypt";

export async function generateSad(
  providerPublicKeyBase64,
  userToken,
  dbts,
  certId,
  userPin,
  hashAlgorithm = "SHA512"
) {
  // Fixed ASN1 header
  const ASN1_HEADER = "MIICITANBgkqhkiG9w0BAQEFAAOCAg4A";

  // Build full public key
  const providerPublicKey = ASN1_HEADER + providerPublicKeyBase64;

  // Calculate SHA1 of user token and convert to Base64
  const userTokenSha1 = await sha1(userToken);
  const userTokenB64 = hexToBase64(userTokenSha1);

  // Initialize encryptor with provider's public key
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(providerPublicKey);

  // Build SAD payload
  const sadPayload = {
    s: certId, // Certificate ID
    p: userPin, // User-provided PIN
    t: userTokenB64, // Token hash
    d: dbts, // Hash from InitSign
    a: hashAlgorithm, // Algorithm
    pd: "", // Reserved (empty)
    i: "" // Integrity (calculated later)
  };

  // Calculate integrity: sha1(s + p + t + d + a + pd) → base64
  const integrityHex = await sha1(
    sadPayload.s +
      sadPayload.p +
      sadPayload.t +
      sadPayload.d +
      sadPayload.a +
      sadPayload.pd
  );
  sadPayload.i = hexToBase64(integrityHex);

  // Encrypt SAD payload
  const sadEncrypted = encryptor.encrypt(JSON.stringify(sadPayload));

  if (!sadEncrypted) {
    throw new Error("Failed to encrypt SAD with provider public key");
  }

  return sadEncrypted;
}

// Utilities
async function sha1(str) {
  const enc = new TextEncoder();
  const hash = await crypto.subtle.digest("SHA-1", enc.encode(str));
  return Array.from(new Uint8Array(hash))
    .map((v) => v.toString(16).padStart(2, "0"))
    .join("");
}

function hexToBase64(hexString) {
  return btoa(
    hexString
      .match(/\w{2}/g)
      .map((a) => String.fromCharCode(parseInt(a, 16)))
      .join("")
  );
}
